import React from 'react';

function Principal() {
  return (
    <section id="principal" className="principal-section">
      <div className="section-container">
        <div className="section-title-block">
          <h2 className="section-title">
             Message from the Principal
          </h2>
          <div className="gold-underline"></div>
        </div>
        <div className="principal-content">
          <div className="principal-image">
            <div className="principal-photo-frame">
              <img src="/principal.jpg" alt="Principal Mrs. Afrina Banu Dyawapur" className="principal-photo" />
            </div>
            <div className="principal-id-card">
              <h3>Mrs. Afrina Banu Dyawapur</h3>
              <p className="principal-title-tag">Principal — M.Sc Nursing</p>
              <p className="principal-college-tag">Paramananda College of Nursing</p>
              <p className="principal-location-tag">📍 Bengaluru, Karnataka</p>
            </div>
          </div>
          <div className="principal-message">
            <div className="principal-quote-icon">"</div>
            <blockquote>
              Nursing is not just a profession; it is a sacred calling to serve humanity with
              compassion, knowledge, and excellence. At Paramananda College of Nursing, we nurture
              future healthcare leaders who are ready to make a meaningful difference in people's
              lives — in India and across the globe.
            </blockquote>
            <p>
              Welcome to Paramananda College of Nursing (PCN). Our institution is dedicated to providing
              excellence in nursing education through a perfect blend of theoretical knowledge, practical
              clinical exposure, and character development. We are recognized by the Government of Karnataka,
              affiliated with Rajiv Gandhi University of Health Sciences (RGUHS), and approved by the
              Indian Nursing Council (INC) and Karnataka Nursing Council.
            </p>
            <p>
              Our state-of-the-art infrastructure, experienced faculty, and strong hospital partnerships
              ensure that every PCN graduate enters the workforce as a competent, compassionate, and
              globally competitive healthcare professional.
            </p>
            <div className="principal-btns">
              <button className="btn btn-primary">Read Full Message</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Principal;